import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
import DocumentPreview from 'components/modules/shipments/stops/DocumentPreview';
import { sluggify } from 'utils/localization/utils';
export default function UploadedDocumentPreviewModal({ name, url, onHide }) {
    const { t } = useTranslation();
    function getBody() {
        return ((React.createElement("div", { "data-testid": "div-0c02a51e", className: "flex w-full" },
            React.createElement("div", { "data-testid": "div-8bba01cf", className: "mx-auto" },
                React.createElement(DocumentPreview, { height: "100%", width: "100%", url: url })))));
    }
    function getFooter() {
        return ((React.createElement("div", { "data-testid": "div-fcf2a2a4", className: "flex items-center justify-end" },
            React.createElement("button", { "data-testid": "button-3442656e", className: "button button-secondary", type: "button", onClick: onHide }, t('CANCEL')))));
    }
    return ((React.createElement(CargomaticModal, { dataTestId: "CargomaticModal-49aa2a72", style: { top: '5%' }, dialogClassName: 'modal-override-medium', title: t(sluggify(name)), show: true, onHide: onHide, body: getBody(), footer: getFooter() })));
}
